export default __webpack_public_path__ + "static/media/paymentMethodMaster.a3d2bcaa.svg";